import { PublicToolbar } from '../../ui/Toolbar/PublicToolbar';
import { useLoggedIn } from '@/hooks/useProfile';
import { AuthToolbar } from './AuthToolbar';
import { createRef } from 'react';
import { useLocation } from 'react-router-dom';

const NO_TOOLBAR = ['/signin', '/signup', '/recover', '/verifyemail', '/503'];
export const toolbarRef = createRef<HTMLDivElement>();

export const Toolbar = () => {
  const isLoggedIn = useLoggedIn();
  const location = useLocation();

  if (NO_TOOLBAR.some((it) => location.pathname.startsWith(it))) {
    return null;
  }

  return (
    <div style={{ top: 0, position: 'sticky', zIndex: 1004 }} ref={toolbarRef}>
      {isLoggedIn ? <AuthToolbar /> : <PublicToolbar />}
    </div>
  );
};
